<g transform="translate(-11, 0)">
  <circle cx="11" cy="11" r="11" class="fill-yellow-300" />
  <g transform="translate(4.5, 4.5)">
    <path
      d="M7 0C3.134 0 0 2.686 0 6c0 2.433 1.582 4.503 3.784 5.358L3.5 14l3.149-2.264C7.548 11.912 7.271 12 7 12c3.866 0 7-2.686 7-6s-3.134-6-7-6z"
      class="fill-yellow-50 stroke-yellow-400 stroke-0.5"
    />
  </g>
</g>
